<template>
    <div class="box">
        
        <div class="logo">
            <img class="logo-one" src="@/assets/ystitle.png" alt="">
            <p class="logo-text logo-textre">关于阳狮集团中国</p>
        </div>
        <div class="logor">
            <p>一个阳狮</p>
            <p class="logorp">The Power of One</p>
        </div>
        <div class="title">
            <img class="header-main-j header-main-jde" src="@/assets/mainj.png" alt="">
            <img class="header-main-dd" src="@/assets/maindd.png" alt="">
            <div class="title-text">
                <p>阳狮集团是全球传播领域的领导者。深耕中国市场逾30年,阳狮集团中国于上海、北京、广州、济南、深圳等城市设立办公室，汇聚近4000名专业人士，构建起覆盖全国的服务网络。</p>
                <p>
                    阳狮集团是客户实现规模化与个性化升级转型的卓越合作伙伴。集团业务覆盖从咨询到执行的每一个价值链环节,将营销转型与数字业务转型相结合。集团采用“一个阳狮(Power of One)”的高度协同模式,深度拥抱人工智能,助力企业在变革时代构建可持续竞争力。
                </p>
                <p>
                    阳狮集团旗下汇聚传播、媒体、数据与技术四大核心业务领域,协同Leo、盛世长城、星传媒体、百比赫、实力媒体、明思力等代理品牌,为客户提供制胜解决方案。凭借卓越的业务表现与人才战略,阳狮集团屡获戛纳国际创意节、Spikes Asia、One Show、Campaign Asia年度代理商及艾菲等大奖认可,并荣膺“中国2026年度杰出雇主”认证。
                </p>
            </div>
        </div>
        <div class="line">
            <img class="" src="@/assets/yson.png" alt="">
            <img class="" src="@/assets/ysone.png" alt="">
        </div>
        <div class="logor">
            <img class="logo-tow" src="@/assets/ystit.png" alt="">
        </div>
        <div class="logoe">
            <img class="logoe-one" src="@/assets/ysmain.png" alt="">
            <img class="logoe-tow" src="@/assets/ysmaine.png" alt="">
        </div>

        <!-- ===================== 下面是修改后的 3个并列模块 ===================== -->
        <div class="bottom">
            <img class="header-main-j" src="@/assets/minty.png" alt="">
            <img class="header-main-ddd" src="@/assets/ysddd.png" alt="">
            <img class="header-main-dddd" src="@/assets/ysdddd.png" alt="">
            <div class="item">
                <img src="@/assets/yszq.png" alt="">
                <div class="text">
                    <p>是我们的工作方式</p>
                    <p>对人才的培养、对作品的创作、对创新的坚持...</p>
                    <p>对卓越的不懈追求，是我们的信念底色</p>
                </div>
            </div>
            <div class="item">
                <img src="@/assets/ysjs.png" alt="">
                <div class="text">
                    <p>是我们的互动模式</p>
                    <p>以善意建立连接，关心彼此、支持伙伴</p>
                    <p>我们让善意自然流淌，让每一次连接都有价值</p>
                </div>
            </div>
            <div class="item">
                <img src="@/assets/ysbj.png" alt="">
                <div class="text">
                    <p>是我们的行动风格</p>
                    <p>以轻快无拘的姿态，保持创造力与敏捷性</p>
                    <p>我们为尝试提供空间，让探索得以实现</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>

</script>

<style scoped>
.box {
    width: 100%;
    height: auto;
    overflow-x: hidden;
}

.logo {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}

.logor {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
    text-align: center;
    font-family: 'Noto Sans SC', sans-serif;
  font-weight: 700;
  color: #ff5453;
  font-size: 36px;
}
.logor p{
    margin: 0;
    padding: 0;
}
.logor .logorp{
    margin-top: -10px;
}

.logo img,
.logor img {
    display: block;
    margin: 0 auto;
}

.logo-one {
    width: 40%;
}

.logo-tow {
    width: 20%;
}

.logoe {
    width: 100%;
}

.logoe img {
    width: 1420px;
    margin: 0 auto;
    margin-top: 40px;
}

.logoe-one {
    display: block;
}

.logoe-tow {
    display: none;
}

.title {
  width: 900px;
  margin: 40px auto 0 auto;
  font-size: 21.5px;
  color: #4d4d4d;
  position: relative;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;

  text-align: justify;
  /* 中文专用对齐 */
  text-justify: inter-ideograph;
  /* 关键：短行、最后一行 不拉伸，左对齐 */
  text-align-last: left;
  line-height: 1.6;
}
.title p {
  text-align: justify;
  text-align-last: left;
  /* 兼容你手动 <br> 换行 */
  white-space: normal;
}
.titlere{
    display: block;
    width: 100%;
}
.titlera{
    display: none;
    width: 100%;
}
.brae {
  /* 字号跟随正文，不要自定义大小 */
  font-size: inherit;
  margin: 0;
  padding: 0;
}
.line {
    width: 900px;
    margin: 0 auto;
    height: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
}

.line>img {
    width: 45%;
    height: 90%;
}

/* ===================== 底部样式：电脑端3个并排 ===================== */
.bottom {
    width: 1000px;
    margin: 40px auto 150px auto;
    display: flex;
    justify-content: space-around;
    gap: 25px;
    color: #4d4d4d;
    position: relative;
}

.bottom .item {
    flex: 1;
    text-align: center;
}

.bottom .item img {
    width: 70%;
    height: auto;
    margin-bottom: 10px;
}

.bottom .text {
    width: 100%;
    margin: 0 auto;
}

.bottom .text p {
    margin: 5px 0;
    line-height: 1.5;
    font-size: 15px;
    font-family: 'Noto Sans SC', sans-serif;
    font-weight: 350;
    white-space: nowrap;
}

.header-main-j {
    position: absolute;
    left: -140px;
    top: -40%;
    width: 17px;
    height: auto;
}

.header-main-jde {
    left: -140px;
    top: -20%;
    width: 14px;
}

.header-main-ddd {
    position: absolute;
    left: -180px;
    top: -320%;
    width: 40%;
    height: auto;
}

.header-main-dddd {
    position: absolute;
    right: -240px;
    top: 20%;
    width: 15%;
    height: auto;

}

.header-main-dd {
    position: absolute;
    right: -20%;
    top: -70%;
    width: 120px;
    height: auto;
}

.nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #F87373;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    z-index: 9999;
}

.nav-item {
    cursor: pointer;
    font-size: 16px;
    color: #333;
    transition: color 0.3s ease;
    font-family: 'Noto Sans SC', sans-serif;
    font-weight: 350;
}

.nav-itemhover {
    color: #fff;
}

.bra {
    display: none;
}

.bre {
    display: block;
}

.brae {
    /* font-size: 15px; */
}
.logo-text{
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 40px;
    color: black;
    font-family: 'Noto Sans SC', sans-serif;
    font-weight: 700;
}
.logo-textre{
    margin: 0;
}
.title-text{
    font-family: 'Noto Sans SC', sans-serif;
    font-weight: 350;
    font-size: 19px;
}
.logtext{
}
/* ===================== 移动端：自动变成一列 ===================== */
@media (max-width: 768px) {
    .logoe-one {
        display: none;
    }

    .logoe-tow {
        display: block;
    }

    .title {
        width: 85%;
        font-size: 12px;
        margin-top: 20px;
    }

    .logo {
        width: 100%;
        margin-top: 20px;
    }

    .logor {
        width: 100%;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .logo-one {
        width: 70%;
    }

    .logo-tow {
        width: 40%;
    }

    .line {
        margin-top: 10px;
        width: 85%;
        height: 100px;
    }

    /* 移动端单列样式 */
    .bottom {
        width: 80% !important;
        flex-direction: column;
        gap: 35px;
    }

    .header-main-j {
        position: absolute;
        left: -20px;
        top: 80px;
        width: 6px;
        height: auto;
    }

    .header-main-dd {
        position: absolute;
        right: -40px;
        top: 0%;
        width: 35px;
        height: auto;
    }

    .nav-bar {
        height: 50px;
        gap: 15px;
        /* padding: 0 10px; */
    }

    .nav-item {
        font-size: 12px;
    }

    .bra {
        display: block;
    }

    .bre {
        display: none;
    }

    .brae {
        font-size: 10px;
    }
    /* 👇 加在你的 @media (max-width:768px) 里面 */
.title,
.title p {
  text-align: left !important;
  text-justify: auto !important;
  text-align-last: left !important;
}
.logor{
    font-size: 20px;
}
.logo-text{
    font-size: 21px;
}
.titlere{
    display: none;
    width: 100%;
}
.titlera{
    display: block;
    width: 100%;
}
.logo-textre{
    font-size: 20px;
}
.logoe img {
    width: 100%;
}
.box{
    width: 375px;
    margin: 0 auto;
    /* margin-top: 40px; */
}
.bottom .text p{
    font-size: 14px;
}
.title-text{
    font-size: 12.5px;
}
.logtext{
}

}
</style>